import { set } from '@/utils/vuex'

export default {
  listTarifsRecords: set('listTarifsRecords'),
  listTarifsState: set('listTarifsState'),
  addCategorieState: set('addCategorieState'),
  setTarifState: (state, payload) => {
    state.tarifsState[payload.clientId + '/' + payload.categorieId] = payload.state
    return state
  },
  updateCountIncrement: (state) => {
    state.updateCount++
    return state
  }
}
